import styled from 'styled-components';
import { Colors } from '../style/GlobalStyles';

const SectionContainer = styled.section`
  width: 100%;
`;

const CardWithVideo = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  border-radius: 20px;
  background: ${Colors.ink};
`;

const Video = styled.video`
  width: 100%;
  height: 70vh;
  object-fit: cover;
  display: block;

  @media (max-width: 768px) {
    height: 45vh;
  }
`;

const VideoCard = ({ url }) => {
  return (
    <SectionContainer>
      <CardWithVideo>
        <Video autoPlay muted loop playsInline>
          <source src={url} type="video/mp4" />
          Tu navegador no soporta video HTML5.
        </Video>
      </CardWithVideo>
    </SectionContainer>
  );
};

export default VideoCard;
